import React, { useState } from "react";
import { useNavigate,Link } from "react-router-dom"; // Import for routing
import { FaPhoneAlt, FaSearch, FaCheck, FaArrowRight } from "react-icons/fa";
import "../Css/PatientCare.css";
import patientImage from "../assets/japa.jpg";




const Japamaid = () => {

    const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  // List of your services
  const services = [
  { name: "Patient Care", path: "/services/patient-care-service-in-mumbai" },
  { name: "Baby Care", path: "/services/baby-care-service-in-mumbai" },
  { name: "House Maid", path: "/services/house-maid-service-in-mumbai" },
  { name: "Cooking", path: "/services/cooking-service-in-mumbai" },
  { name: "Driver", path: "/services/driver-service-in-mumbai" },
  { name: "Home Cleaning", path: "/services/home-cleaning-service-in-mumbai" },
  { name: "Japa Maid", path: "/services/japa-maid-service-in-mumbai" },
];

  // Filter logic
  const filteredServices = services.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  
  return (
    <div className="patientcare-page">
      {/* HERO SECTION - RETAINED AS REQUESTED */}
      <section className="patientcare-hero">
        <div className="patientcare-overlay">
          <div className="patientcare-hero-content">
            <h1>Japa Maid Services</h1>
            <p>
              <span><a href="/">Home</a></span> / <span className="active">Japa Maid Services</span>
            </p>
          </div>
        </div>
      </section>

      {/* SQUARE PREMIUM CONTENT */}
      <section className="main-section">
        <div className="container-square">
          <div className="content-layout">
            
            {/* Main Content Area */}
            <div className="article-box">
              <div className="square-img-holder">
                <img src={patientImage} alt="Patient Care Services" />
                <div className="img-overlay-label">PREMIUM SERVICE</div>
              </div>

              <div className="text-header">
                <h2 className="title-bold">Top-Rated Japa Maid in Mumbai – Skilled & Trustworthy</h2>
                <h4 className="subtitle-line">Verified Japa Maid for Households Mumbai</h4>
              </div>

              <div className="body-description">
                <p>SVK Maid Service is proud to offer specialized postnatal care through our reliable and compassionate Japa Maid Service Mumbai. We understand that the arrival of a newborn brings immense joy along with the need for careful attention and support for both the mother and baby. Our trained Japa maids are dedicated professionals who ensure that new mothers get the rest, care, and recovery time they need while providing gentle and safe assistance for newborns.</p>
                <p>At SVK Maid Service, we carefully select each Japa maid after thorough background verification, health checks, and skill assessments. Our team is highly experienced in traditional Indian postpartum care methods, ensuring both modern hygiene and age-old nurturing practices are followed. Whether you need short-term or extended assistance after childbirth, our Japa maids offer complete, reliable support.</p>
                {/* <p>We offer comprehensive <b>Patient Care Maid Service in Mumbai</b> for individuals recovering from illness, surgery, or those requiring regular assistance due to age or disability. Our maids are compassionate, attentive, and professionally trained to handle various caregiving responsibilities while maintaining respect and dignity for the patient.</p> */}
              </div>

              {/* Why Choose - Modern Square Grid */}
              <div className="why-choose-square">
                <h3>Why Choose SVK Maid Service for Japa Maids?</h3>
                <div className="grid-features">
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Expert Newborn Care:</strong> Our Japa maids are skilled in handling newborns safely, including feeding, bathing, and ensuring proper sleep routines.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Mother Care and Recovery:</strong> They assist mothers with massage, nutrition guidance, and rest, helping with faster recovery post-delivery.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Hygienic and Safe Practices:</strong>All maids follow strict hygiene standards to keep both mother and baby safe and comfortable.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Flexible Durations:</strong> Choose from daily, weekly, or monthly plans to fit your family’s needs.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Verified and Trained Staff:</strong>Comprehensive background checks and professional training ensure trustworthy service.</p>
                  </div>
                </div>
              </div>

              <div className="summary-footer-box">
                <p>Our Professional Japa Maid Mumbai services go beyond basic care. These maids understand the emotional and physical needs of new mothers, offering both companionship and practical help. From preparing healthy meals and herbal baths to maintaining cleanliness in the baby’s room, our maids handle every small detail with care and respect.</p>
              </div>
              <div className="summary-footer-box">
                <p>When you are looking for a Skilled Japa Maid for Hire, SVK Maid Service stands as your dependable partner. We provide customized service packages that match your specific postnatal requirements. Our clients appreciate our transparent hiring system, prompt customer service, and the professionalism of every maid we employ.</p>
              </div>
              <div className="summary-footer-box">
                <p>Known as a Trusted Japa Maid Agency Mumbai, SVK Maid Service is committed to building lasting trust through quality, compassion, and reliability. With our Experienced Japa Maid Mumbai, you can focus on bonding with your baby while we take care of everything else.</p>
              </div>
            </div>

            {/* Square Sidebar */}
            <aside className="sidebar-square">
              {/* ACTIVE SEARCH BOX */}
      <div className="search-container-premium">
        <div className="search-square">
          <input
            type="text"
            placeholder="SEARCH SERVICES..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button><FaSearch /></button>
        </div>

        {/* Search Results Dropdown */}
        {searchTerm && (
          <div className="search-results-dropdown">
            {filteredServices.length > 0 ? (
              filteredServices.map((service, index) => (
                <div
                  key={index}
                  className="result-item"
                  onClick={() => navigate(service.path)}
                >
                  {service.name}
                </div>
              ))
            ) : (
              <div className="no-result">No services found</div>
            )}
          </div>
        )}
      </div>

              <div className="list-widget">
                <h5>OUR SERVICES</h5>
                <ul className="square-links">
  <li>
    <Link to="/services/patient-care-service-in-mumbai">
      Patient Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/baby-care-service-in-mumbai">
      Baby Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/house-maid-service-in-mumbai">
      House Maid <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/cooking-service-in-mumbai">
      Cooking <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/driver-service-in-mumbai">
      Driver <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/home-cleaning-service-in-mumbai">
      Home Cleaning <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link
      to="/services/japa-maid-service-in-mumbai"
      className="active-item"
    >
      Japa Maid <FaArrowRight />
    </Link>
  </li>
</ul>
              </div>

<div className="contact-box-square">
  <div className="cta-overlay-square">
    <div className="cta-icon-square">
      <FaPhoneAlt />
    </div>
    <h3 className="cta-title-square">Call us Today!</h3>
    <a href="tel:+919152151180" className="cta-phone-square">
      +91 91521 51180
    </a>
    <a href="mailto:info@svkmaidservice.com" className="cta-email-square">
      info@svkmaidservice.com
    </a>
  </div>
</div>
            </aside>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Japamaid;